import { useState, useEffect } from 'react';
import getData from '../../../utils/getData';
import itemsList from '../../../utils/updatedItemsList.js';
import picUnavailable from '../../../res/picUnavailable.png';
import { MdDeleteForever } from 'react-icons/md';

////ASYNC FUNCTIONS
async function getItemInfo(itemId, itemEnchant, itemLocation, itemQuality) {
  const today = new Date();
  const past = new Date();
  past.setDate(past.getDate() - 30);
  let url2 = `https://www.albion-online-data.com/api/v2/stats/history/${itemId}${itemEnchant
  }?locations=${itemLocation}&qualities=${
    itemQuality
  }&time-scale=24
  &date=
  ${past.toLocaleDateString()}
  &end_date=
  ${today.toLocaleDateString()}`;
  let itemInfoRes = await getData(url2);
  return itemInfoRes.data[0];
}

const useItemCardLogic = (setItemsSelected, listItemsSelected, item) => {
  ////STATES
  const [itemInfoRes, setItemInfoRes] = useState({ data: [{ avg_price: 0 }] });
  const [itemObj, setItemObj] = useState({
    location: item.itemLocation,
    itemId: item.itemId,
    enchant: item.itemEnchant,
    quality: item.itemQuality,
    itemName:itemsList.filter(listItem => item.itemId === listItem.itemId)[0]
    .itemName,
    canEnchant:item.canEnchant,
    id: item.id
  });
  const [hideQualityList,setHideQualityList] = useState(true)
  const [hideLocationList,setHideLocationList] = useState(true)
  const [hideEnchantList,setHideEnchantList] = useState(true)

  ////FUNCTIONS
  function formatPrices(price) {
    if (price) {
      return price
        .toString()
        .split('.')[0]
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return 'No Data';
  }
  function totalSold(array) {
    let count = 0;
    array.forEach(item => {
      count += item.item_count;
    });
    return count;
  }

  function deleteItemFromList(id) {
    const arrayWithoutItem = listItemsSelected.filter(
      listItem => listItem.id !== id
    );
    setItemsSelected(arrayWithoutItem);
  }

  function updateItem(type, value) {
    switch (type) {
      case 'location':
        setItemObj(prevState => {
          return { ...prevState, location: value }
        });
        break;
      case 'enchant':
        setItemObj(prevState => {
          return { ...prevState, enchant: value }
        });
        break;
      case 'quality':
        setItemObj(prevState => {
          return { ...prevState, quality: value }
        });
        break;
      default:
      return
    }
  }

  useEffect(() => {
    const FetchItems = async () => {
      let itemInfoRes = await getItemInfo(
        itemObj.itemId,
        itemObj.enchant,
        itemObj.location,
        itemObj.quality
      );
      setItemInfoRes(itemInfoRes);
      return;
    };
    FetchItems();
  }, [itemObj.itemId, itemObj.enchant, itemObj.location, itemObj.quality]);

  return {
    //STATE
    itemInfoRes,
    itemObj,
    hideQualityList,
    hideLocationList,
    hideEnchantList,
    //SET STATES
    setHideQualityList,
    setHideLocationList,
    setHideEnchantList,
    //VARIABLES
    itemsList,
    picUnavailable,
    //FUNCTIONS
    formatPrices,
    deleteItemFromList,
    totalSold,
    updateItem,
    //COMPONENTS
    MdDeleteForever,
  };
};

export default useItemCardLogic;
